module.exports = __webpack_public_path__ + "static/media/DSC04745.28719cf5.JPG";